import { useQuery } from '@tanstack/react-query';

import { getCustomerSelectOptionById } from './customers';
import { TypesenseCollection } from '../types';
import { useGetTypeSenseAPIKeys } from '@/api/REST/typeSenseAPIKeys';

const CUSTOMER_OPTION_KEY = 'customerOption';

export const useGetCustomerOptionById = (id: number | string | undefined) => {
  const _id = id && typeof id === 'string' ? id : (id?.toString() ?? undefined);

  const { data: apiKeys } = useGetTypeSenseAPIKeys();
  const collectionApiKey =
    apiKeys?.[TypesenseCollection.CUSTOMERS_VIEW.keyName]?.key ?? null; // use _VIEW key here, if a user has no view access, it also has no higher access

  const { data, ...restProps } = useQuery({
    queryKey: [CUSTOMER_OPTION_KEY, _id, collectionApiKey],
    queryFn: () => getCustomerSelectOptionById(_id!, collectionApiKey!),
    enabled: !!_id && !!collectionApiKey,
  });

  return { data, ...restProps };
};
